import { useActiveStore } from '@/store/activePages';

// Components
import Tab from '@/components/Tab';
import Tabs from '@/components/Tabs';
import useBreakpoint from '@/hooks/useBreakpoint';
import useVerifySMSConfirmationIsOn from '@/hooks/useVerifySMSConfimationIsOn/useVerifySMSConfimationIsOn';
import { useFormStore } from '@/store/form';

// Wizard Tabs
const ShortFlowWizardTabs = () => {
  const activePages = useActiveStore((store) => store.pages);
  const isPortability = useFormStore((store) => store.isPortability);
  const isMigration = useFormStore((store) => store.isMigration);
  const ddd = useFormStore((store) => store.value.tel).slice(0, 2);
  const smsFromPortabilityIsOn = useVerifySMSConfirmationIsOn(
    ddd,
    isPortability(),
  );
  const validationStepIsOn = isMigration() ? true : smsFromPortabilityIsOn;

  const { isOnBreakpoint: isTableOrLess } = useBreakpoint(1024);

  const defaultTabsData = [
    {
      name: isTableOrLess ? 'você' : 'sobre você',
      id: 'personal-data',
    },
    {
      name: 'produto',
      id: 'type-product',
    },
    {
      name: isTableOrLess ? 'finalizando ' : 'finalizando pedido',
      id: 'short-flow-finish-order',
    },
    {
      name: 'validação',
      id: 'short-flow-sms-confirmation',
    },
  ];

  const tabsData = validationStepIsOn
    ? defaultTabsData
    : defaultTabsData.filter((tab) => tab.id !== 'payment-data/sms');
  return (
    <Tabs className='px-4 pt-4 pb-2 lg:mt-0 lg:px-10 lg:pb-4 lg:pt-6'>
      {tabsData.map((tab) => {
        const status = activePages.has(`/${tab.id}`) ? 'active' : 'disabled';

        return <Tab key={tab.id} name={tab.name} status={status} />;
      })}
    </Tabs>
  );
};

export default ShortFlowWizardTabs;
